import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import {
  MmButtonModule,
  MmIconModule,
} from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';

import { CookieDisclaimerService } from './services/cookie-disclaimer.service';
import { CookieConsentConfig } from './models/cookie-consent-config.interface';
import { CookieConsentConfigToken} from './tokens/cookie-consent.token';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MmIconModule,
    MmButtonModule,
    OverlayModule,
    RouterModule,
    TranslateModule,
    QaLocatorsModule
  ],
  exports: [],
  providers: []
})
export class CookieConsentModule {
  public static forRoot(configFactory: () => CookieConsentConfig): ModuleWithProviders<CookieConsentModule> {
    return {
      ngModule: CookieConsentModule,
      providers: [
        CookieDisclaimerService,
        {
          provide: CookieConsentConfigToken,
          useFactory: configFactory,
        },
      ],
    };
  }
}

export { CookieDisclaimerService };
